import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import Flex from '../../../../../components/common/Flex';
import { Badge, Card, Col, FormLabel, Row } from 'react-bootstrap';
import VehiculoKilometrajeChart from './VehiculoKilometrajeChart';
import classNames from 'classnames';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../../../../components/common/IconButton';
import { obtenerIconoVehiculo } from '../../../../../components/common/google-maps-selector/IconosTabla';

const VehiculoKilometraje = ({
    data,
    onSelectVehicle,
    highlightedVehicle,
    vehiculoFiltrado,
    handleFiltro,
    title = "Kilómetros por Vehículo"
}) => {
    const [verDetalle, setVerDetalle] = useState(true);

    // Validar datos
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    // Procesar los datos para el formato requerido
    const vehiculosConKM = data.map((vehiculo, index) => {
        const totalGlobalKM = data.reduce((sum, v) => sum + v.totalKM, 0);
        const percentage = totalGlobalKM > 0 ? ((vehiculo.totalKM / totalGlobalKM) * 100) : 0;

        return {
            ...vehiculo,
            percentage: percentage.toFixed(1),
            id: vehiculo.vehiculoUid || index,
            title: vehiculo.title || `${vehiculo.no_economico || 'N/A'} / ${vehiculo.alias || 'N/A'}`
        };
    });

    // Ordenar por kilómetros totales (descendente)
    vehiculosConKM.sort((a, b) => b.totalKM - a.totalKM);

    // Listado con todos los vehiculos filtrados --------------------------
    let dataListCard = null;

    // Ningun filtro seleccionado
    if (!vehiculoFiltrado) {

        //Almacena en local (Todos los vehiculos filtrados)
        window.localStorage.setItem('vehicles_km_all', JSON.stringify(vehiculosConKM));

        //Listamos en la tabla todos los vehiculos encontrados 
        dataListCard = vehiculosConKM;
    }
    else {

        //Si ya fueron eliminados los vehiculos de la informacion (Obenemos todos los vehiculos)
        const localStorageData = window.localStorage.getItem("vehicles_km_all");

        //Listamos en la tabla todos los vehiculos encontrados
        dataListCard = JSON.parse(localStorageData);
    }

    //------------------------------------------------------------------------

    // Calcular totales
    const totalKilometros = vehiculosConKM.reduce((total, vehiculo) => total + vehiculo.totalKM, 0);
    const totalVehiculos = vehiculosConKM.length;

    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    return (
        <Card className="h-100">
            <FalconCardHeader
                title={vehiculoFiltrado ? `${title}: ${vehiculoFiltrado}` : title}
                titleTag="h6"
                light
                endEl={
                    <>
                        {vehiculoFiltrado && (
                            <IconButton
                                className='mx-2'
                                onClick={handleFiltro}
                                icon="times-circle"
                                size="sm"
                                variant="falcon-default">
                                Remover filtro
                            </IconButton>
                        )}

                        {/*<IconButton
                            onClick={() => setVerDetalle(!verDetalle)}
                            icon="eye"
                            size="sm"
                            variant="falcon-default">
                            {!verDetalle ? 'Ver detalle' : 'Ocultar detalle'}
                        </IconButton>*/}
                    </>
                }
            />

            <Card.Body as={Row}>
                {/* ✅ GRÁFICO DE DONA */}
                <Col md={(!verDetalle ? 12 : 4)} className="mb-xxl-1 align-content-center">
                    <VehiculoKilometrajeChart
                        data={vehiculosConKM}
                        onSelectVehicle={onSelectVehicle}
                        totalKM={totalKilometros}
                    />
                </Col>

                {/* ✅ DETALLE DE VEHÍCULOS */}
                <Col md={8} hidden={!verDetalle}>
                    <div className="overflow-auto pe-x1" style={{ maxHeight: '300px' }}>
                        <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
                        {dataListCard.map((vehiculo, index) => {
                            let isLast = index === dataListCard.length - 1;
                            let highlighted = highlightedVehicle === vehiculo.title;
                            return (<div>
                                <Row
                                    className={classNames(
                                        'position-relative align-items-center py-2 g-0 flex-nowrap',
                                        { 'border-bottom border-200': !isLast },
                                        { 'text-danger fw-bold': highlighted }
                                    )} style={{ minWidth: '350px' }} href="#!" onClick={(e) => {
                                        e.preventDefault();
                                        onSelectVehicle({
                                            title: vehiculo.title,
                                            id: vehiculo.vehiculoUid,
                                            totalKM: vehiculo.totalKM,
                                            totalDias: vehiculo.totalDias
                                        });
                                    }}
                                >
                                    <Col className="py-1 ps-x1">
                                        <Flex className="justify-content-between"  >
                                            <Row className='mx-0 px-0' style={{ width: '55%' }}>
                                                <Flex className={classNames(
                                                    'm-0 p-0 align-items-center text-truncate flex-grow-1 flex-nowrap',
                                                    { 'fw-bold': highlighted }
                                                )} tag="h6" style={{ ...style }}>
                                                    <div className="me-2">
                                                        {obtenerIconoVehiculo(vehiculo.tipo_vehiculo, vehiculo.color_vehiculo)}
                                                    </div>
                                                    <a className={classNames('label-detail-card px-0 mx-0', {
                                                        'fw-bold': highlighted,
                                                    })}
                                                        style={{ fontSize: '14px', ...style, color: highlighted ? vehiculo.color_vehiculo : '#212121' }}
                                                        title={vehiculo.title}>
                                                        {vehiculo.title}
                                                    </a>
                                                </Flex>
                                            </Row>
                                            <Row className="flex-nowrap justify-content-between g-0" >

                                                <div className='ps-2 text-start m-0' style={{ width: '50%' }}>
                                                    <Badge pill bg="200" className=' mt-0'>
                                                        <div className="m-0 fs-10 fw-semibold" style={{ color: highlighted ? vehiculo.color_vehiculo : '#212121' }}> {vehiculo.totalKM.toFixed(2)} km</div>
                                                    </Badge>
                                                </div>
                                                <div className="ps-2 justify-content-end d-flex flex-nowrap" style={{ width: '50%' }}>

                                                    <Badge pill bg="200" className="my-1 text-primary" style={{ width: '60px' }}>
                                                        {vehiculo.percentage}%
                                                    </Badge>
                                                    <a className="ps-2" style={{
                                                        color: highlighted ? vehiculo.color_vehiculo : 'inherit', width: '20px'
                                                    }}>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </a>
                                                </div>
                                            </Row>
                                        </Flex>
                                    </Col >
                                </Row >
                            </div >
                            );
                        })}
                    </div>
                </Col>
            </Card.Body>

            <Card.Footer hidden={!verDetalle}>
                <Row className='justify-content-end text-end border-top border-200 pt-2'>
                    <div className="fw-bold label-detail-card">Total de vehículos: {totalVehiculos}</div>
                </Row>
            </Card.Footer>
        </Card>
    );
};

VehiculoKilometraje.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        vehiculoUid: PropTypes.string,
        title: PropTypes.string,
        no_economico: PropTypes.string,
        alias: PropTypes.string,
        totalKM: PropTypes.number.isRequired,
        totalDias: PropTypes.number.isRequired,
        fechaCorta: PropTypes.string,
        tipo_vehiculo: PropTypes.string,
        color_vehiculo: PropTypes.string
    })).isRequired,
    onSelectVehicle: PropTypes.func.isRequired,
    highlightedVehicle: PropTypes.string,
    vehiculoFiltrado: PropTypes.string,
    handleFiltro: PropTypes.func,
    title: PropTypes.string
};

export default memo(VehiculoKilometraje);